var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphql(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.82 119.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.38 34.11 52.91 8.44 8.44 34.11 8.44 85.47 52.91 111.14 97.38 85.47 97.38 34.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "52.91 8.44 8.44 85.47 97.38 85.47 52.91 8.44"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 52.91,
    cy: 8.44,
    r: 8.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 52.91,
    cy: 111.14,
    r: 8.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 97.38,
    cy: 85.47,
    r: 8.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 97.38,
    cy: 34.11,
    r: 8.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.44,
    cy: 34.11,
    r: 8.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.44,
    cy: 85.47,
    r: 8.44
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphql);
export default __webpack_public_path__ + "static/media/graphql.eccb31e0b044dd636c8e928751400782.svg";
export { ForwardRef as ReactComponent };